import { render, staticRenderFns } from "./StarfieldDashboard.vue?vue&type=template&id=164c6604&scoped=true"
import script from "./StarfieldDashboard.vue?vue&type=script&lang=ts"
export * from "./StarfieldDashboard.vue?vue&type=script&lang=ts"
import style0 from "./StarfieldDashboard.vue?vue&type=style&index=0&id=164c6604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164c6604",
  null
  
)

export default component.exports